import {
  GlobalDatabases,
  getGlobalDatabaseInstance,
} from '../manager/databaseManager';
import { UserDBStores, UserKeyStore, UserStorageFlags } from '../schemas';
import { AppWindow, ApplicationType } from '../../../windows/types';
import { Section, SectionsState } from '../../../sections/types';
import { ResultWithOptionalError } from '../../types/generic/results';
import { decrypt, encrypt } from '../../cryptor/cipher';
import moment from 'moment';
import { getActiveWindowId, getUserDBName, readUserFlag } from './helpers';
import { TrashData } from './types';

export const getUserEncFeKey = async (userId: string, id: string) => {
  const db = await getGlobalDatabaseInstance(
    getUserDBName(userId),
    GlobalDatabases.User
  );

  const encFeKey = await db
    .table(UserDBStores.Keys)
    .get(id ?? UserKeyStore.MasterFeKey);

  return encFeKey;
};

export const saveUserEncFeKey = async (
  userId: string,
  encFeKey: string,
  id: string
): Promise<ResultWithOptionalError<boolean>> => {
  try {
    const db = await getGlobalDatabaseInstance(
      getUserDBName(userId),
      GlobalDatabases.User
    );

    await db
      .table(UserDBStores.Keys)
      .put(encFeKey, id ?? UserKeyStore.MasterFeKey);
    return {};
  } catch (error) {
    console.log(error);
    return {
      error: new Error(error as string),
    };
  }
};

export interface UserUIData {
  windows: AppWindow[];
  sections: Partial<SectionsState>;
  // sheetsHistory: SheetManagerHistory;
  isManualSave: boolean;
  activeWindowId: undefined | string;
}
export const loadUserUiData = async (
  userId: string,
  feKey: CryptoKey
): Promise<ResultWithOptionalError<UserUIData>> => {
  try {
    const db = await getGlobalDatabaseInstance(
      getUserDBName(userId),
      GlobalDatabases.User
    );

    const encWindows: string[] = await db.table(UserDBStores.Windows).toArray();
    const windows: AppWindow[] = [];
    for (let encWindow of encWindows) {
      const decWindow = await decrypt(encWindow, feKey);
      if (decWindow) windows.push(JSON.parse(decWindow));
    }

    windows.sort((a, b) => {
      const dateA = moment(a.createdDate); //'YYYY-MM-DD HH:mm:ss'
      const dateB = moment(b.createdDate); // 'YYYY-MM-DD HH:mm:ss'
      return dateA.diff(dateB);
    });

    const activeWindowId = await getActiveWindowId(db);

    const sectionIds = Object.values(Section);
    const sections: Partial<SectionsState> = {};

    for (const sectionId of sectionIds) {
      const section = await db.table(UserDBStores.Sections).get(sectionId);
      if (section) {
        const key = (sectionId + 'Section') as keyof SectionsState; //e.g topSection bottomSection
        const decSection = await decrypt(section, feKey);
        if (decSection) sections[key] = JSON.parse(decSection);
        // sections[key] = JSON.parse(section);
      }
    }

    // let sheetsHistory: SheetManagerHistory = {
    //   past: [],
    //   future: [],
    // };
    // const historyResult = await loadUserSheetHistory(userId, feKey);
    // if (historyResult.data) {
    //   sheetsHistory = historyResult.data;
    // }

    const isManualSave = await readUserFlag(
      db,
      UserStorageFlags.ManualSaveMode
    );

    return {
      data: {
        windows,
        sections,
        // sheetsHistory,
        isManualSave,
        activeWindowId,
      },
    };
  } catch (error) {
    return {
      error: new Error(error as string),
    };
    // return new Err(error as string);
  }
};

// export const loadUserSheetHistory = async (
//   userId: string,
//   feKey: CryptoKey
// ): Promise<ResultWithOptionalError<SheetManagerHistory>> => {
//   try {
//     const db = await getGlobalDatabaseInstance(
//       getUserDBName(userId),
//       GlobalDatabases.User
//     );

//     const past = await readUserSheetHistory(db, feKey, UserDBStores.Past);
//     const unsortedFuture = await readUserSheetHistory(
//       db,
//       feKey,
//       UserDBStores.Future
//     );

//     return {
//       data: {
//         past,
//         future: _.reverse(unsortedFuture),
//       },
//     };
//   } catch (error) {
//     return {
//       error: new Error(error as string),
//     };
//   }
// };

// export const startClearUserSheetHistory = async (userId: string) => {
//   try {
//     const db = await getGlobalDatabaseInstance(
//       getUserDBName(userId),
//       GlobalDatabases.User
//     );

//     await clearUserSheetHistory(db);

//     return {};
//   } catch (error) {
//     return {
//       error: new Error(error as string),
//     };
//   }
// };

export const putDataInTrash = async (
  userId: string,
  feKey: CryptoKey,
  id: string,
  data: TrashData
) => {
  const recordKey = `${id}-${data.appType}`;
  const db = await getGlobalDatabaseInstance(
    getUserDBName(userId),
    GlobalDatabases.User
  );

  const encData = await encrypt(JSON.stringify(data), 'trash', feKey);

  await db.table(UserDBStores.Trash).put(encData, recordKey);
};

export const removeDataFromTrash = async (
  userId: string,
  id: string,
  appType: ApplicationType
) => {
  const recordKey = `${id}-${appType}`;
  const db = await getGlobalDatabaseInstance(
    getUserDBName(userId),
    GlobalDatabases.User
  );

  await db.table(UserDBStores.Trash).delete(recordKey);
};

// export const generateUniqueSheetName = async (userId: string) => {
//   const db = await getGlobalDatabaseInstance(
//     getUserDBName(userId),
//     GlobalDatabases.User
//   );

//   db.table(UserDBStores.Sheets)
// };
